
 <div class="dashboard-card">
    <img src="assets/dashboard_img.svg" alt="Soufiane FADIL">
        <div class="header">
            <h2>Thinking of where to start?</h2>
            <div class="dash-text">There are no classes added to your profile. 
                You may want to start by adding one or more classes. 
                Remember that a class is dependent on a Level, a Subject, 
                a Supervisor and a defined set.</div>
        </div>
</div> 